import { useEffect, useState } from "react";

/**
 * The client clock, re-read every `intervalMs` while `enabled`.
 *
 * `Date.now()` in render is impure, so components that draw time (a
 * countdown, a "now" line) read it from here. Re-enabling refreshes on the
 * next tick of the event loop, so a countdown that starts after a long idle
 * stretch never shows the stale mount-time clock for a whole interval.
 */
export function useNow(intervalMs: number, enabled = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    const kick = window.setTimeout(() => setNow(Date.now()), 0);
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => {
      window.clearTimeout(kick);
      window.clearInterval(id);
    };
  }, [intervalMs, enabled]);
  return now;
}
